/* eslint-disable no-return-assign */
import { apiV1, apiV2 } from "@/store";

const state = {
  dashboardPaymentPlans: "",
  dashboardPromiseToPays: "",
  failedPayments: [],
  pendingPayments: [],
  paymentPlans: [],
  planCart: [],
  planDate: "",
  planMonths: "2",
  planMonthlyCost: "",
  promiseCart: "",
  promiseDate: "",
  promiseToPays: [],
  promiseMonths: "1",

  switchStatus: false,

  tenantsToBeCalled: []
};

const actions = {
  getFailedPayments: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`payment-plans/failed-payments`)
        .then((resp) => {
          commit("setFailedPayments", resp.data.failed_payments);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getPendingPayments: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`payment-plans/pending-plans-with-upcoming-payments`)
        .then((resp) => {
          commit("setPendingPayments", resp.data.plans);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getTenantsToBeCalled: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`ar-tenants/to-be-called`, {
        params: params
      })
        .then((resp) => {
          commit("setTenantsToBeCalled", resp.data.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  searchPaymentPlans: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`payment-plans`, {
        params: {
          status: payload.status,
          perPage: payload.perPage,
          page: payload.page,
          sortBy: payload.sortBy,
          sortDirection: payload.sortDirection
        }
      })
        .then((resp) => {
          commit("setDashboardPaymentPlans", resp.data.payment_plans);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getAllPaymentPlansForTenant: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`facilities/${payload.facilityId}/tenants/${payload.tenantId}/payment-plans`)
        .then((resp) => {
          commit("setPaymentPlans", resp.data.payment_plans);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  searchPromiseToPays: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`payment-plans/scheduled-payments`, {
        params: {
          status: payload.status,
          per_page: payload.per_page,
          page: payload.page,
          sort_by: payload.sort_by,
          sort_direction: payload.sort_direction
        }
      })
        .then((resp) => {
          commit("setDashboardPromiseToPays", resp.data.scheduled_payments);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  resendScheduledPaymentAgreementEmail: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      let createResendAgreementPayload = {
        email_address: payload.email_address,
        update_email: payload.update_email
      };

      apiV1.post(`payment-plans/scheduled-payments/${payload.id}/resend-agreement`, createResendAgreementPayload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  resendPaymentPlanAgreementEmail: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      let createResendAgreementPayload = {
        email_address: payload.email_address,
        update_email: payload.update_email
      };

      apiV1.post(`payment-plans/${payload.id}/resend-agreement`, createResendAgreementPayload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getAllPromisesToPayForTenant: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`facilities/${payload.facilityId}/tenants/${payload.tenantId}/scheduled-payments`)
        .then((resp) => {
          commit("setPromiseToPays", resp.data.scheduled_payments);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // This is for the payment plan side
  createPaymentPlan: ({}, payload) => {
    return new Promise((resolve, reject) => {
      let createPaymentPlanPayload = {
        start_date: payload.start_date,
        duration: payload.duration,
        total_balance: payload.total_balance,
        monthly_rate: payload.monthly_rate,
        status: payload.status,
        tenant_id: payload.tenant_id,
        ledger_id: payload.ledger_id,
        facility_id: payload.facility_id,
        unit_id: payload.unit_id,
        first_name: payload.first_name,
        last_name: payload.last_name,
        email: payload.email,
        phone: payload.phone
      };

      apiV1.post(`payment-plans/`, createPaymentPlanPayload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  generateMonthlyRate: ({}, payload) => {
    return new Promise((resolve, reject) => {
      apiV2.get(`facilities/${payload.facility_id}/tenants/${payload.external_tenant_id}/ledgers/${payload.external_ledger_id}/monthly-rate`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  generatePlanCost: ({}, payload) => {
    return new Promise((resolve, reject) => {
      let generatePlanPayload = {
        total_balance: payload.total_balance,
        monthly_rate: payload.monthly_rate
      };

      apiV1.post(`payment-plans/plan-cost`, generatePlanPayload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // This is for the promise-to-pay side
  createScheduledPromisePayment: ({}, payload) => {
    return new Promise((resolve, reject) => {
      let createPromisePayload = {
        payment_date: payload.payment_date,
        payment_amount: payload.payment_amount,
        status: payload.status,
        tenant_id: payload.tenant_id,
        ledger_id: payload.ledger_id,
        facility_id: payload.facility_id,
        unit_id: payload.unit_id,
        first_name: payload.first_name,
        last_name: payload.last_name,
        email: payload.email,
        phone: payload.phone
      };

      apiV1.post(`payment-plans/scheduled-payments`, createPromisePayload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  cancelPaymentPlan: ({}, planId) => {
    return new Promise((resolve, reject) => {
      apiV1.delete(`payment-plans/${planId}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  cancelPromiseToPay: ({}, planId) => {
    return new Promise((resolve, reject) => {
      apiV1.delete(`payment-plans/scheduled-payments/${planId}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  markTenantSkipped: ({}, tenantId) => {
    return new Promise((resolve, reject) => {
      apiV1.patch(`ar-tenants/${tenantId}/mark-as-skipped`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const mutations = {
  resetAccountsReceivableState: (state) => {
    state.dashboardPaymentPlans = "";
    state.dashboardPromiseToPays = "";
    state.failedPayments = [];
    state.paymentPlans = [];
    state.planCart = [];
    state.planDate = "";
    state.planMonths = "2";
    state.planMonthlyCost = "";
    state.promiseCart = [];
    state.promiseDate = "";
    state.promiseToPays = [];
    state.promiseMonths = "1";
    state.switchStatus = false;
  },
  updatePlanCart: (state, planCart) => {
    state.planCart = planCart;
  },
  resetPlanCart: (state) => {
    state.planCart = [];
    state.planMonthlyCost = "";
  },
  updatePlanDate: (state, planDate) => {
    state.planDate = planDate;
  },
  updateMonthlyCost: (state, monthlyCost) => {
    state.planMonthlyCost = monthlyCost;
  },
  setFailedPayments: (state, failedPayments) => {
    state.failedPayments = failedPayments;
  },
  setPendingPayments: (state, pendingPayments) => {
    state.pendingPayments = pendingPayments;
  },
  setDashboardPaymentPlans: (state, dashboardPaymentPlans) => {
    state.dashboardPaymentPlans = dashboardPaymentPlans;
  },
  setDashboardPromiseToPays: (state, dashboardPromiseToPays) => {
    state.dashboardPromiseToPays = dashboardPromiseToPays;
  },
  setPaymentPlans: (state, paymentPlans) => {
    state.paymentPlans = paymentPlans;
  },
  setPlanMonths: (state, planMonths) => {
    state.planMonths = planMonths;
  },
  setPromiseToPays: (state, promiseToPays) => {
    state.promiseToPays = promiseToPays;
  },
  setPromiseMonths: (state, promiseMonths) => {
    state.promiseMonths = promiseMonths;
  },
  updatePromiseCart: (state, promiseCart) => {
    state.promiseCart = promiseCart;
  },
  resetPromiseCart: (state) => {
    state.promiseCart = [];
  },
  updatePromiseDate: (state, date) => {
    state.promiseDate = date;
  },
  setTenantsToBeCalled: (state, tenantsList) => {
    state.tenantsToBeCalled = tenantsList;
  },
  updateSwitchStatus: (state, value) => {
    state.switchStatus = value;
  }
};

function getPromiseToPayTotal(promiseToPay) {
  return promiseToPay.reduce((acc, currVal) => {
    return acc += parseFloat(currVal.dcTotal);
  }, 0);
};

const getters = {

  ledgersEligibleForPaymentPlan: (state, getters, rootState) => {
    return rootState.tenant.ledgers.filter(ledger => {
      return ledger.is_eligible_for_payment_plan;
    }).map(eligibleLedger => eligibleLedger.pms_ledger_id);
  },

  ledgersEligibleForPromiseToPay: (state, getters, rootState) => {
    return rootState.tenant.ledgers.filter(ledger => {
      return ledger.is_eligible_for_promise_to_pay;
    }).map(eligibleLedger => eligibleLedger.pms_ledger_id);
  },

  selectedPromiseToPay: (state) => {
    if (state.promiseCart && state.promiseCart.in_cart) {
      const totalDue = state.promiseMonths === "1"
        ? getPromiseToPayTotal(state.promiseCart.this_month)
        : getPromiseToPayTotal(state.promiseCart.next_month);

      return {
        unit_id: state.promiseCart.this_month[0].UnitID,
        ledger_id: state.promiseCart.this_month[0].LedgerID,
        unit_name: state.promiseCart.this_month[0].sUnitName,
        total_due: totalDue
      };
    }
  },

  selectedPaymentPlan: (state) => {
    if (state.planCart && state.planCart.facility_unit) {
      let monthlyPaymentCost;

      if (state.planCart && state.planMonths === "2") {
        monthlyPaymentCost = state.planMonthlyCost.two_months;
      } else if (state.planCart && state.planMonths === "3") {
        monthlyPaymentCost = state.planMonthlyCost.three_months;
      } else {
        monthlyPaymentCost = 0;
      }

      return {
        unit_name: state.planCart.facility_unit.name,
        total_due: monthlyPaymentCost,
        unit_id: state.planCart.unit_id,
        ledger_id: state.planCart.pms_ledger_id // external
      };
    }
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
